import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import classnames from 'classnames'
import { adminAddFaculty } from '../../../redux/action/adminAction'
import AdminHomeHelper from '../../../Components/AdminHomeHelper'


const AdminAddFaculty = () => {
    const store = useSelector((state) => state)
    const dispatch = useDispatch()
    const history = useHistory()
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [department, setDepartment] = useState('')
    const [designation, setDesignation] = useState('')
    const [facultyMobileNUmber, setFacultyMobileNumber] = useState('')
    const [dob, setDob] = useState('')
    const [gender, setGender] = useState('')
    const [aadharCard, setAadharCard] = useState('')
    const [bloodGroup, setBloodGroup] = useState('');
    const [religion, setReligion] = useState('');
    const [community, setCommunity] = useState('');
    const [motherName, setMotherName] = useState('');
    const [fatherOccupation, setFatherOccupation] = useState('');
    const [motherOccupation, setMotherOccupation] = useState('');
    const [annualIncome, setAnnualIncome] = useState('');
    const [bankAccountNumber, setBankAccountNumber] = useState('');
    const [IFSCcode, setIFSCcode] = useState('');
    const [bankName, setBankName] = useState('');
    const [branch, setBranch] = useState('');
    const [address, setAddress] = useState('');
    const [fathersName, setFathersName] = useState('');
    const [ParentNumber, setParentNumber] = useState('');
    const [bankBranch, setBankBranch] = useState('');
    const [joiningYear, setJoiningYear] = useState('');

    const [error, setError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [avatar, setAvatar] = useState('')
    const imagehandler = (e) => {
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0]
            setAvatar(img)
            console.log(img)
        }
    }


    useEffect(() => {
        if (store.error) {
           setError(store.error)
       }
    }, [store.error])
    const formHandler = (e) => {
        e.preventDefault();
        setIsLoading(true);
    
        // Create a new FormData object
        const formData = new FormData();
    
        // Append the form fields to the formData object
        formData.append("name", name);
        formData.append("email", email);
        formData.append("designation", designation);
        formData.append("facultyMobileNUmber", facultyMobileNUmber);
        formData.append("department", department);
        formData.append("aadharCard", aadharCard);
        formData.append("gender", gender);
        formData.append("branch", branch);
        formData.append("address", address);
        formData.append("fathersName", fathersName);
        formData.append("ParentNumber", ParentNumber);
        formData.append("dob", dob.split("-").reverse().join("-"));
        formData.append("bloodGroup", bloodGroup);
        formData.append("religion", religion);
        formData.append("community", community);
        formData.append("motherName", motherName);
        formData.append("fatherOccupation", fatherOccupation);
        formData.append("motherOccupation", motherOccupation);
        formData.append("annualIncome", annualIncome);
        formData.append("bankAccountNumber", bankAccountNumber);
        formData.append("IFSCcode", IFSCcode);
        formData.append("bankName", bankName);
        formData.append("bankBranch", bankBranch);
        formData.append("joiningYear", joiningYear);
        formData.append("avatar", avatar);
    
        // Dispatch the action with the formData
        dispatch(adminAddFaculty(formData));
    }
    

    useEffect(() => {
        if (store.admin.adminAddFacultyFlag) {
            setError({})
        }
    }, [store.admin.adminAddFacultyFlag])

    useEffect(() => {
        if (store.error || store.admin.adminAddFacultyFlag) {
            setIsLoading(false)
        }
        else {
            setIsLoading(true)
        }
    },[store.error,store.admin.adminAddFacultyFlag])
    return (
       
        <div>
            {store.admin.isAuthenticated ? (<>
                <div className="container-fluid">
                    <div className="row ">
                        <div className="col-3 p-0">
                        <AdminHomeHelper/>
                        </div>
                        <div className="col-9 ">
                        <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                        <h5><Link to='/admin/allFaculties' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>
                                <h3> <img src="/logo192.png" width={'50px'} alt="" />Add Faculty</h3>
                                <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                            </div>
                            <form noValidate onSubmit={formHandler}>
                                <div className="row">
                                    <div className="col-md-6">
                                        
                                        <div className="form-group">
                                            <label htmlFor="nameId">Faculty Name</label>
                                            <input onChange={(e) => setName(e.target.value)} type="text" className={classnames("form-control",
                                                {
                                                    'is-invalid': error.name
                                                })} id="nameId" />
                                            {error.name && (<div className="invalid-feedback">{error.name}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="emailId">Email</label>
                                            <input onChange={(e) => setEmail(e.target.value)} type="email" className={classnames("form-control",
                                                {
                                                    'is-invalid': error.email
                                                })} id="emailId" />
                                            {error.email && (<div className="invalid-feedback">{error.email}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="designationId">Designation</label>
                                            <select onChange={(e) => setDesignation(e.target.value)} className={classnames("form-control",
                                                {
                                                    'is-invalid': error.designation
                                                })} id="designationId">
                                                <option>Select</option>
                                                <option value="Head of Department">Head of Department</option>
                                                <option value="Assistant Professor">Assistant Professor</option>
                                                <option value="Senior Professer">Senior Professer</option>
                                            </select>
                                            {error.designation && (<div className="invalid-feedback">{error.designation}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="departmentId">Department</label>
                                            <select onChange={(e) => setDepartment(e.target.value)} className={classnames("form-control",
                                                {
                                                    'is-invalid': error.department
                                                })} id="departmentId">
                                                <option>Select</option>
                                                <option value="ECE">ECE</option>
                                                <option value="CSE">CSE</option>
                                                <option value="EEE">EEE</option>
                                                <option value="AIDS">AIDS</option>
                                                <option value="MECH">MECH</option>
                                                <option value="CIVIL">CIVIL</option>
                                                <option value="BIO">BIO</option>
                                                <option value="AGRI">AGRI</option>
                                                <option value="MBA">MBA</option>
                                                <option value="MCA">MCA</option>
                                            </select>
                                            {error.department && (<div className="invalid-feedback">{error.department}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="fathersNameId">Father's Name</label>
                                            <input
                                                onChange={(e) => setFathersName(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.fathersName,
                                                })}
                                                id="fathersNameId"
                                            />
                                            {error.fathersName && (<div className="invalid-feedback">{error.fathersName}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="bloodGroupId">Blood Group</label>
                                            <input
                                                onChange={(e) => setBloodGroup(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.bloodGroup,
                                                })}
                                                id="bloodGroupId"
                                            />
                                            {error.bloodGroup && (<div className="invalid-feedback">{error.bloodGroup}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="addressId">Address</label>
                                            <input
                                                onChange={(e) => setAddress(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.address,
                                                })}
                                                id="addressId"
                                            />
                                            {error.address && (<div className="invalid-feedback">{error.address}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="religionId">Religion</label>
                                            <input
                                                onChange={(e) => setReligion(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.religion,
                                                })}
                                                id="religionId"
                                            />
                                            {error.religion && (<div className="invalid-feedback">{error.religion}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="communityId">Community</label>
                                            <input
                                                onChange={(e) => setCommunity(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.community,
                                                })}
                                                id="communityId"
                                            />
                                            {error.community && (<div className="invalid-feedback">{error.community}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="motherNameId">Mother's Name</label>
                                            <input
                                                onChange={(e) => setMotherName(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.motherName,
                                                })}
                                                id="motherNameId"
                                            />
                                            {error.motherName && (<div className="invalid-feedback">{error.motherName}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="fatherOccupationId">Father's Occupation</label>
                                            <input
                                                onChange={(e) => setFatherOccupation(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.fatherOccupation,
                                                })}
                                                id="fatherOccupationId"
                                            />
                                            {error.fatherOccupation && (<div className="invalid-feedback">{error.fatherOccupation}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="motherOccupationId">Mother's Occupation</label>
                                            <input
                                                onChange={(e) => setMotherOccupation(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.motherOccupation,
                                                })}
                                                id="motherOccupationId"
                                            />
                                            {error.motherOccupation && (<div className="invalid-feedback">{error.motherOccupation}</div>)}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="branchId">Branch</label>
                                        <input
                                            onChange={(e) => setBranch(e.target.value)}
                                            type="text"
                                            className={classnames("form-control", {
                                                'is-invalid': error.branch,
                                            })}
                                            id="branchId"
                                        />
                                        {error.branch && (<div className="invalid-feedback">{error.branch}</div>)}
                                    </div>
                                    <div className="form-group">
                                            <label htmlFor="parentNumberId">Parent's Number</label>
                                            <input
                                                onChange={(e) => setParentNumber(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.ParentNumber,
                                                })}
                                                id="parentNumberId"
                                            />
                                            {error.ParentNumber && (<div className="invalid-feedback">{error.ParentNumber}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="dobId">DOB</label>
                                            <input onChange={(e) => setDob(e.target.value)} type="date" className={classnames("form-control",
                                                {
                                                    'is-invalid': error.dob
                                                })} id="dobId" />
                                            {error.dob && (<div className="invalid-feedback">{error.dob}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="genderId">Gender</label>
                                            <select onChange={(e) => setGender(e.target.value)} className="form-control" id="genderId">
                                                <option>Select</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Other">Other</option>
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="numberId">Contact Number</label>
                                            <input onChange={(e) => setFacultyMobileNumber(e.target.value)} type="number" className="form-control" id="numberId" />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="aadharId">Aadhar Card Number</label>
                                            <input onChange={(e) => setAadharCard(e.target.value)} type="number" className="form-control" id="aadharId" />
                                        </div>
                                        
                                        <div className="form-group">
                                            <label htmlFor="annualIncomeId">Annual Income</label>
                                            <input
                                                onChange={(e) => setAnnualIncome(e.target.value)}
                                                type="number"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.annualIncome,
                                                })}
                                                id="annualIncomeId"
                                            />
                                            {error.annualIncome && (<div className="invalid-feedback">{error.annualIncome}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="bankAccountNumberId">Bank Account Number</label>
                                            <input
                                                onChange={(e) => setBankAccountNumber(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.bankAccountNumber,
                                                })}
                                                id="bankAccountNumberId"
                                            />
                                            {error.bankAccountNumber && (<div className="invalid-feedback">{error.bankAccountNumber}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="IFSCcodeId">IFSC Code</label>
                                            <input
                                                onChange={(e) => setIFSCcode(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.IFSCcode,
                                                })}
                                                id="IFSCcodeId"
                                            />
                                            {error.IFSCcode && (<div className="invalid-feedback">{error.IFSCcode}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="bankNameId">Bank Name</label>
                                            <input
                                                onChange={(e) => setBankName(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.bankName,
                                                })}
                                                id="bankNameId"
                                            />
                                            {error.bankName && (<div className="invalid-feedback">{error.bankName}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="bankBranchId">Bank Branch</label>
                                            <input
                                                onChange={(e) => setBankBranch(e.target.value)}
                                                type="text"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.bankBranch,
                                                })}
                                                id="bankBranchId"
                                            />
                                            {error.bankBranch && (<div className="invalid-feedback">{error.bankBranch}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="joiningYearId">Joining Year</label>
                                            <input
                                                onChange={(e) => setJoiningYear(e.target.value)}
                                                type="number"
                                                className={classnames("form-control", {
                                                    'is-invalid': error.joiningYear,
                                                })}
                                                id="joiningYearId"
                                            />
                                            {error.joiningYear && (<div className="invalid-feedback">{error.joiningYear}</div>)}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="inputId">Profile Picture</label>
                                            <input required className="form-control" type="file" accept=".jpg,.png,.jpeg" id="inputId" onChange={imagehandler}></input>
                                        </div>

                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-md-1">
                                        {
                                            isLoading && <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                                {!isLoading && <button type="submit" className="btn btn-info">Add Faculty</button>}
                            </form>
                        </div>
                    </div>
                </div></>):(history.push('/'))}
            
        </div>



    )
}

export default AdminAddFaculty
